export const healthDatebooks = [
  {
    id: "health-caregiver-2027",
    displayName: "2027 Caregiver Datebook",
    description: "A practical planning system for family caregivers and patient advocates navigating a health crisis.",
    price: 19.95,
    thumbnailImage: "Caregiver_cover_old.jpg",
    images: [
      "Caregiver_cover.jpg",
      "caregiver1.jpg",
      "caregiver2.jpg",
      "caregiver3.jpg"
    ],
    category: "HEALTH"
  },
  {
    id: "health-companion-2027",
    displayName: "2027 Health Companion Datebook",
    description: "A personal wellness planner to help organize appointments, medications, fitness, nutrition, and health goals.",
    price: 19.95,
    thumbnailImage: "Health Companion_cover.jpg",
    images: [
      "Health Companion_cover.jpg",
      "healthCare1.jpg",
      "healthCare2.jpg",
      "healthCare3.jpg",
    ],
    category: "HEALTH"
  }
];